import React from 'react';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { Media, Text } from '../../../../components';
import {
  StyledContainer,
  StyledHeadline,
  StyledMainDescription,
} from '../../styled';

const Musicians = ({
  title,
  description,
}: {
  description: string;
  title: string;
}) => {
  return (
    <StyledContainer>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={2} colSpan={4}>
            <Grid>
              <Container.FullBleed>
                <Cell.MaxWidth>
                  <StyledHeadline headline={title} />
                </Cell.MaxWidth>
                <Cell.MaxWidth>
                  <StyledMainDescription size="l">
                    {description}
                  </StyledMainDescription>
                </Cell.MaxWidth>
                <Cell.Basic colSpan={9}>
                  <Text size="m">
                    Founded in 1980 and based in Frankfurt am Main, the
                    activities of the grassroots-democratically organised
                    ensemble are currently shaped by 18 soloists. The musicians
                    from Belgium, Bulgaria, Germany, Greece, India, Israel,
                    Japan, Switzerland and the USA decide on their projects
                    together, as well as collaborations with other artists and
                    all economic issues. The
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    Ensemble Modern's aesthetic spectrum includes musical and
                    dance-theatrical genres, multimedia forms as well as chamber
                    music, ensemble and orchestra concerts.
                  </Text>
                </Cell.Basic>
                <Cell.Basic colSpan={6}>
                  <ul>
                    <li>
                      <Text size="m">Dietmar Wiesner – Flute</Text>
                    </li>
                    <li>
                      <Text size="m">Jaan Bossier – Clarinet</Text>
                    </li>
                    <li>
                      <Text size="m">Sava Stoianov – Trumpet</Text>
                    </li>
                    <li>
                      <Text size="m">Uwe Dierksen – Trombone</Text>
                    </li>
                  </ul>
                </Cell.Basic>
                <Cell.Basic colSpan={6}>
                  <ul>
                    <li>
                      <Text size="m"> Megumi Kasakawa – Viola</Text>
                    </li>
                    <li>
                      <Text size="m">Jagdish Mistry – Viola</Text>
                    </li>
                    <li>
                      <Text size="m">Eva Böcker – Cello</Text>
                    </li>
                    <li>
                      <Text size="m">Maria Kasper – Cello</Text>
                    </li>
                  </ul>
                </Cell.Basic>
              </Container.FullBleed>
            </Grid>
          </Cell.Basic>
          <Cell.Basic colStarts={7} colSpan={5}>
            <Media imgUrl="./images/info-pages/info-musicians.jpg" />
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledContainer>
  );
};

export default Musicians;
